import { Component, OnInit } from '@angular/core';
import { BankAccountDataService } from '../../services/bank-account-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-linked-account-details',
  templateUrl: './linked-account-details.component.html',
  styleUrls: ['./linked-account-details.component.scss']
})

/**
 * This component appears in the flow after the linking accounts screen.
 */
export class LinkedAccountDetailsComponent implements OnInit {
  bankAccountList;
  fipDetail;
  constructor(
    private accData: BankAccountDataService,
    private route: Router
  ) { }

  ngOnInit() {
    this.getSelectedFip();
    this.getAccounts();
  }

  /**
   * To get linked accounts Data
   */
  getAccounts() {
    if (this.accData.getLinkedAccounts()) {
      this.bankAccountList = this.accData.getLinkedAccounts().linkedAccounts;
    }
  }

  /**
   * To navigate to dashboard page after removing discovery and linking accounts data from the local storage
   */
  gotoDashboard() {
    this.accData.removeLocalStorageItems();
    this.route.navigate(['/dashboard']);
  }

  /**
   * To know the Fip Name , so it could show the fip logo
   */
  getSelectedFip(){
    this.fipDetail=this.accData.getSelectedFip();
  }
}
